import { render } from "./productCategoryFinal.vue?vue&type=template&id=3747c836&scoped=true"
import script from "./productCategoryFinal.vue?vue&type=script&lang=js"
export * from "./productCategoryFinal.vue?vue&type=script&lang=js"

import "./productCategoryFinal.vue?vue&type=style&index=0&id=3747c836&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3747c836"]])

export default __exports__